export default class UpdateAvatarViewModel{
    originFileName: string;
    contentType: string;
    blobToUpload: any;
}